import React from 'react'
import {AlertDialog} from 'react-onsenui'
import {connect} from "react-redux";
import {hideAlertMessage} from "../../modules/alert";
import {withRouter} from "react-router-dom";

class AlertMessage extends React.Component {
    constructor(props) {
        super(props);
    }

    state = {
        typeName : {restricted: '접근 오류'}
    };

    componentDidMount(){
    }

    componentWillReceiveProps(nextProps) {
    }


    componentWillMount() {
    }

    alertConfirm = () => {
        switch (this.props.alertType){
            case 'restricted':
                this.props.history.push(this.props.redirectUrl);
                this.props.hideAlertMessage();
                break;
            case 'custom':
                this.props.hideAlertMessage();
                break;
            default:
                console.error('NO TARGET');
        }
    };

    render() {
        return (
           <div>
               <AlertDialog
                   isOpen={this.props.showAlert}
                   isCancelable={false}
                   className="alert-wrapper">
                   <div className='alert-dialog-title'>{this.props.alertType === 'custom'? this.props.alertTitle : this.state.typeName[this.props.alertType]}</div>
                   <div className='alert-dialog-content'>
                       {this.props.alertMessage}
                   </div>
                   <div className='alert-dialog-footer'>
                       <button onClick={this.alertConfirm} className='alert-dialog-button'>
                           확인
                       </button>
                   </div>
               </AlertDialog>
           </div>
        )
    }
}

const mapStateToProps = ({ alert }) => ({
    showAlert: alert.showAlert,
    alertType: alert.alertType,
    alertMessage: alert.alertMessage,
    redirectUrl: alert.redirectUrl,
    alertTitle: alert.alertTitle
});

const mapDispatchToProps = dispatch => ({
    hideAlertMessage: () => dispatch(hideAlertMessage())
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(AlertMessage))